import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Generate a unique session ID for this browser session
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('psn_session_id');
  if (!sessionId) {
    sessionId = 'sess_' + Math.random().toString(36).substring(2, 15) + Date.now().toString(36);
    sessionStorage.setItem('psn_session_id', sessionId);
  }
  return sessionId;
};

const PageTracker = () => {
  const location = useLocation();
  const lastTrackedPath = useRef(null);

  useEffect(() => {
    // Don't track admin pages to avoid inflating stats
    if (location.pathname.startsWith('/admin')) {
      return;
    }

    // Avoid duplicate tracking for the same path
    if (lastTrackedPath.current === location.pathname) {
      return;
    }
    lastTrackedPath.current = location.pathname;

    // Track the page view
    const trackPageView = async () => {
      try {
        const formData = new FormData();
        formData.append('page', location.pathname);
        formData.append('session_id', getSessionId());

        await fetch(`${BACKEND_URL}/api/track/pageview`, {
          method: 'POST',
          body: formData
        });
      } catch (error) {
        // Silently fail - don't disrupt user experience for analytics
        console.debug('Page view tracking failed:', error);
      }
    };

    // Small delay to ensure page has loaded
    const timeoutId = setTimeout(trackPageView, 100);
    return () => clearTimeout(timeoutId);
  }, [location.pathname]);

  return null; // This component doesn't render anything
};

export default PageTracker;
